import React, { useCallback, useState } from 'react';
import { useLiveViewContext } from "./LiveViewProvider";
import { mapToMomentFormat } from "../../../utils/helper";

const MapLiveViewMeta = () => {
        const { state, setState } = useLiveViewContext();
    const { courseData, playersLiveData, courseLoading, liveDataLoading, selectedCourse, courseList,holes_details } = state;
    const { course_name = '' } = courseData || {};
    const { updated_at, live_players_count } = playersLiveData || {};
    const [dropdown, setDropdown] = useState(false);

    const handleSelect = (course) => {
        setDropdown(false);
        setState(_state => ({
            ..._state,
            selectedCourse: course
        }));
            localStorage.setItem("selectedLiveCourseId", course.id);

        console.log(playersLiveData);
    };

    const renderCourseListView = useCallback(() => {
        return (
            <div className="custom-select-wrapper">
                <div style={{ cursor: "pointer" }} className={dropdown ? "custom-select open" : "custom-select"}>
                    <div className="custom-select__trigger" onClick={() => setDropdown(!dropdown)}>
                        <div style={{ cursor: "pointer", color: "white" }} className="text-jost-sb-19 dropdown-btn">{course_name}</div>
                    </div>
                    <div className="custom-options">
                        {dropdown && courseList.map(course =>
                            <span className="custom-option" onClick={() => handleSelect(course)} key={course.id} data-value="">{course.course_name}</span>
                        )}
                    </div>
                </div>
            </div>
        );
    }, [course_name, dropdown, courseList, handleSelect]);

    const renderPlayersData = () => (
        <div className="card__short">
            <div className="card__short__info">
                <h1 className="text-jost-sb-19-wt">LIVE DATA:</h1>
                <div className="card__short__info__date">
                    <h1 className="text-jost-sb-19-wt">DATE:</h1>
                    <span className="text-ops-rg-16-wt">
                        {mapToMomentFormat(Date.now(), 'DD/MM/YY')}
                    </span>
                </div>
                <div className="card__short__info__play">
                    <h1 className="text-jost-sb-19-wt">Current live Players:</h1>
                    <span className="text-ops-rg-16-wt">
                        {live_players_count ? live_players_count : 0}
                    </span>
                </div>
            </div>
        </div>
    );

    if (courseLoading || !courseData) return '';

    return (
        <div className="content-tabs__content___bar">
            {renderCourseListView()}
            {renderPlayersData()}
        </div>
    );
};

export default MapLiveViewMeta;
